<template>
  <div :class="['loading-overlay', $root.config.dark ? 'loading-overlay-dark' : null, visible ? null : 'loading-overlay-hidden']">
    <div>
      <v-progress-circular indeterminate :size="64" :color="$root.colors.primary" />
    </div>
  </div>
</template>
<script>
import events from '../helpers/events'

export default {
  name: 'LoadingOverlay',
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    this.$root.$on(events.ajax, (visible) => {
      this.visible = visible
    })
  }
}
</script>
<style>
.loading-overlay,
.loading-overlay div
{
  user-select: none;
  position: fixed;
}

.loading-overlay
{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: wait;
  z-index: 1000;
  background: rgba(255, 255, 255, .5);
}

.loading-overlay-hidden
{
  display: none;
}

.loading-overlay-dark
{
  background: rgba(0, 0, 0, .5);
}

.loading-overlay div
{
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/loading-overlay.vue